export function createWishlistItemData({ companyId, itemId, wishlistId }) {
  let formData = new FormData();

  formData.append("companyId", companyId);
  formData.append("itemId", itemId);
  formData.append("wishlistId", wishlistId);

  return formData;
}
